export const COOKIE_CATEGORY = Object.freeze({
    NECESSARY: 'necessary',
    PERFORMANCE: 'performance',
    FUNCTIONALITY: 'functionality',
    MARKETING: 'marketing',
});
